"use client";
// Providers are in use client becuase -> https://nextjs.org/docs/getting-started/react-essentials#context

import { ReactQueryProvider } from "@/app-trust/src/lib/providers/react-query-provider";
//import { RouteChangeConfirmationProvider } from "@/utils/RouteChangeConfirmationProvider";
//import { GlobalErrorBoundary } from "@/components/errors/ErrorBoundary";
//import { useLastInteraction } from "@/contexts/LastInteractionContext";
import ReduxProvider from "@/app-trust/src/lib/redux/reduxProvider";
import { ThemeProvider, useTheme } from "next-themes";
import type { FC, ReactNode } from "react";
//import { ThemeProvider as PrimerThemeProvider, BaseStyles as PrimerBaseStyles } from "@primer/react";
//			<PrimerThemeProvider>
//				<PrimerBaseStyles>

interface ProvidersProps {
  children: ReactNode;
  currentUser?: any;
  session?: any;
}
//Providers typically use react context to provide data to their children.
//https://react.dev/learn/passing-data-deeply-with-context
const Providers: FC<ProvidersProps> = ({ children, currentUser, session }) => {
  const { setTheme, theme } = useTheme();
  //const { getLastInteraction } = useLastInteraction();

  return (
    <ThemeProvider attribute="class" defaultTheme="light" forcedTheme={theme}>
      <ReduxProvider>
        <ReactQueryProvider>
          {/*<GlobalErrorBoundary getLastInteraction={getLastInteraction} initialUser={currentUser}>*/}
          {/*<RouteChangeConfirmationProvider>*/}
          {children}
          {/*</RouteChangeConfirmationProvider>*/}
          {/*</GlobalErrorBoundary>*/}
        </ReactQueryProvider>
      </ReduxProvider>
    </ThemeProvider>
  );
};

export default Providers;
